export const DICTATION_CONTEXT_QUERY_KEY = ['DictationContext'] as const;
